/*
 * @Author: wanna.liang
 * @Date: 2021-06-16 10:46:02
 * @Last Modified by: liang
 * @Last Modified time: 2022-03-04 09:19:02
 * axios 封装
 */
import axios from "axios";
import MessageWindow from "components/messageWindow";
import ElementUI from "element-ui";
import { MASTER_DATA_URLS } from "src/services/master-data";
import Auth from "../config/auth";
import { SUBCONTRACT_URIS, DRIVER_URIS, VEHICLE_URIS, TEMPERATURE_URIS, REST_STOP_URIS, TRAILER_URIS } from 'src/services'
import { router } from "../config/routes"

let { isDebug, loginUrl, login_jiuyescm_ticket } = Auth;
let reqObj = {};
const REJECT_ALERT_ERRORS = [
	MASTER_DATA_URLS.ADD_SITE,
	MASTER_DATA_URLS.EDIT_SITE,
	MASTER_DATA_URLS.ADD_CUSTOMER,
	MASTER_DATA_URLS.EDIT_CUSTOMER,
	SUBCONTRACT_URIS.ADD_SUBCONTRACT,
	SUBCONTRACT_URIS.EDIT_SUBCONTRACT,
	DRIVER_URIS.ADD_DRIVER,
	DRIVER_URIS.EDIT_DRIVER,
	VEHICLE_URIS.ADD_VEHICLE,
	VEHICLE_URIS.EDIT_VEHICLE,
	TEMPERATURE_URIS.ADD_TEMPERATURE,
	TEMPERATURE_URIS.EDIT_TEMPERATURE,
	REST_STOP_URIS.ADD_REST_STOP,
	REST_STOP_URIS.EDIT_REST_STOP,
	"/v1/routes/import-schedule",
	TRAILER_URIS.ADD_TRAILER,
	TRAILER_URIS.EDIT_TRAILER_BY_ID,
];

const INCLUDE_REJECT_ERRORS = ["/dt/admin/v1/rest-stop/ANL"];

const checkIncludeRejectError = (url) =>
  INCLUDE_REJECT_ERRORS.some((rejectUrl) => url.includes(rejectUrl));
const REJECT_INTERNAL_SERVER_ERROR = ["/v1/routes/import-schedule"];
import Cookies from "js-cookie";
import { project_env } from "../config/config";
import _this from "./../main.js";
import i18n from "src/lang";
// 请求拦截

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

axios.interceptors.request.use(
  function (config) {
    const routePath = router.history.current.fullPath;
    config.headers["lang"] =
      routePath.includes("master-data") && !routePath.includes("temperature")
        ? "en"
        : Cookies.get(project_env + "language");
    if (isDebug) {
      setCookie("login_cp_ticket_dev", `"${login_jiuyescm_ticket}"`, 3);
      config.headers["login_jiuyescm_ticket"] = `${login_jiuyescm_ticket}`;
      config.headers["login_cp_ticket_dev"] = `${login_jiuyescm_ticket}`;
      config.headers["login_cp_ticket_uat"] = `${login_jiuyescm_ticket}`;
    } else {
      config.withCredentials = true;
    }
    // 百度埋点
    if (_hmt) {
      _hmt.push(["_trackPageview", config.url]);
    }
    reqObj = config;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 响应拦截
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { config } = error;
    if (axios.isCancel(error)) {
      console.log("Request canceled", error.message);
      return;
    }
    // 如果有回调函数,不执行后面的提示
    if (reqObj.errorCB) {
      return Promise.reject(error.response);
    }
    console.log("  =======   请检查接口 ", reqObj.url, error.response.status);
    console.log(error);
    //let errorCode = error.response.status;
    var errorMessage = ""
    try {
      errorMessage = mapResponseMessage(error.response.data.message)
    } catch (e) {
      console.error("Error in getting error message data")
    }
    // 400 先不处理，线上环境都放行了，后面再优化吧
    // if (errorCode === 400) {
    // 	ElementUI.Message({
    // 		showClose: true,
    //         duration:2000,
    // 		type: 'error',
    // 		message: 'SERVER_ERROR 400',
    // 	})
    // }
    if (error.response.status == "401") {
      window.location.href =
        loginUrl + "?app=3&redirect=" + encodeURIComponent(document.URL);
    } else if (
      error.response.status == "400" ||
      error.response.status == "422" ||
      error.response.status == "403"
    ) {
      if (
        !REJECT_ALERT_ERRORS.includes(config.url) &&
        !checkIncludeRejectError(config.url) &&
        !window.location.pathname.includes("trailer/edit")
      ) {
        ElementUI.Message({
          showClose: true,
          duration: 2000,
          type: "error",
          customClass: "messageCustomClass",
          message: errorMessage,
        });
      }
    } else if (error.response.status == "504") {
      ElementUI.Message({
        showClose: true,
        duration: 2000,
        message: message,
        type: "error",
      });
    } else if (error.response.status == "500") {
      // 动态报表详细页下载新加blob报错处理
      if (REJECT_INTERNAL_SERVER_ERROR.includes(config.url)) {
        ElementUI.Message({
          showClose: true,
          duration: 2000,
          type: "error",
          customClass: "messageCustomClass",
          message: errorMessage,
        });
      } else {
        ElementUI.Message({
          showClose: true,
          duration: 2000,
          type: "error",
          customClass: "messageCustomClass",
          message: errorMessage,
        });
        let blobFlag = false;
        if (error.response.data.type == "application/json") {
          blobFlag = true;
          var blobReader = new Response(error.response.data).json();
          blobReader.then((e) => {
            error.response.data = e;
            let messageInfo = {
              title: error.config.url,
              data: error.config.data,
              method: error.config.method,
              content: error.response.data.items,
            };
            MessageWindow({
              type: "error",
              title: _this.$t("public.systemMsg"),
              messageInfo: messageInfo,
              message: errorMessage,
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: _this.$t("public.preview"),
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  instance.showConfirmButton = false;
                  instance.showInfo = true;
                  instance.customClass = "el-message-box-stack";
                } else {
                  instance.showInfo = false;
                  instance.showConfirmButton = true;
                  instance.customClass = null;
                  done();
                }
              },
            })
              .then((action) => {
                done();
              })
              .catch((e) => {
                console.log(e);
                done();
              });
          });
        }

        if (blobFlag) {
          return;
        }
        let messageInfo = {
          title: error.config.url,
          data: error.config.data,
          method: error.config.method,
          content: error.response.data.items,
        };
        MessageWindow({
          type: "error",
          title: _this.$t("public.systemMsg"),
          messageInfo: messageInfo,
          message: errorMessage,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: _this.$t("public.preview"),
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.showConfirmButton = false;
              instance.showInfo = true;
              instance.customClass = "el-message-box-stack";
            } else {
              instance.showInfo = false;
              instance.showConfirmButton = true;
              instance.customClass = null;
              done();
            }
          },
        })
          .then((action) => {
            done();
          })
          .catch((e) => {
            console.log(e);
            done();
          });
      }
    } else {
      ElementUI.Message({
        showClose: true,
        duration: 2000,
        message: errorMessage,
        type: "error",
      });
      // ElementUI.Message.error(error.response.data.message)
      // if (error.response.data.code !== 'INTERNAL_SERVER_ERROR');
    }
    return Promise.reject(error);
  }
);

function mapResponseMessage(message) {
  //console.log("mapResponseMessage: " + message)
  if(!message) {
    return "";
  }
  if(message.includes("Item Name is already existed") || message.includes("Item Code is already existed")) {
    return i18n.t("serviceItem.itemCodeOrNameExists");
  }
  if(message.includes("Invalid parameter.Duplicate project name") || message.includes("Invalid parameter.Duplicate item number")) {
    return i18n.t("product.groupCodeOrNameExists");
  }
  return message;
}

export default axios;



// WEBPACK FOOTER //
// ./src/api/api.config.js